export default "__VITE_ASSET__D3IFqV3o__"